import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
// slices
import mailReducer from './slices/mail';
import chatReducer from './slices/chat';
import productReducer from './slices/product';
import calendarReducer from './slices/calendar';
import taskAssignmentReducer from './slices/taskAssignment';
import userReducer from './slices/user';
import preformReducer from './slices/preFormReducer';
import eventReducer from './slices/event';
import formReducer from './slices/form';
import registerReducer from './slices/register';
import questionnaireReducer from './slices/questionnaire';
import dashboardReducer from './slices/dashboard';

// ----------------------------------------------------------------------

export const rootPersistConfig = {
  key: 'root',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['preformReducer'],
};

export const productPersistConfig = {
  key: 'product',
  storage,
  keyPrefix: 'redux-',
  whitelist: ['sortBy', 'checkout'],
};

const rootReducer = combineReducers({
  mail: mailReducer,
  chat: chatReducer,
  calendar: calendarReducer,
  taskAssignment: taskAssignmentReducer,
  user: userReducer,
  product: persistReducer(productPersistConfig, productReducer),
  event: eventReducer,
  form: formReducer,
  preformReducer,
  registerReducer,
  questionnaire: questionnaireReducer,
  dashboard: dashboardReducer
});

export default rootReducer;
